import { IJobHOCState } from "redux/_core/job/types";
import { ISealLog } from "redux/app/logs/@types";

export interface IDateRange {
    startDate: Date | string | null;
    endDate: Date | string | null;
}

export enum EMarpolBookId {
    ORB1 = 'ORB1',
    ORB4 = 'ORB4',
    CRB = 'CRB',
    GRB1 = 'GRB1',
    GRB2 = 'GRB2',
    BFL2 = 'BFL2',
    BFL1 = 'BFL1',
    ANNEX6 = 'ANNEX6',
    ANNEX6V2 = 'ANNEX6V2',
    BALLAST = 'BALLAST',
    BALLAST_TANK_OPERATIONS = 'BALLAST_TANK_OPERATIONS',
}

export interface IEntry {
    id: string;
    title: string;
    typeOfLogs: string;
    type: string;
	bookType?: string;
}

export interface IFilters {
    dateRange: IDateRange;
    entry?: IEntry;
}

export interface IPagination {
    index: number;
    count: number;
}

export enum EBookType {
    LOG = 'LOG',
    CHECKLIST = 'CHECKLIST',
    PERMIT = 'PERMIT',
    MARPOL = 'MARPOL',
}

export interface IBook {
    title: string;
    id: string;
    type: string;
    bookType: EBookType;
}

export interface IInspectorStore extends IJobHOCState {
    filters: IFilters;
    logs: any[];
    sealLogs: ISealLog[];
    pagination: IPagination;
    selectedLog: any;
    indexOfTasks: any;
    books: IBook[];
    filteredBy: EBookType | null;
    searchBy: string;
    showCoverPages: boolean;
    stateOfScriptInjection: TStateOfScriptInjection;
}

export interface IBallastTankOperationsFilter {
    startDate: any;
    endDate: any;
    shownRecords?: 'ALL' | 'ALL-PENDING';
}

export type TStateOfScriptInjection = 'IDLE' | 'ACTIVE' | 'ENDED';

export enum ETenantName {
    EPS = 'EPS',
    TEEKAY = 'TEEKAY',
    DEFAULT = 'WAYSHIPDEV',
	OTHERS= 'OTHERS',
}

export type TLogbookPersonnel = {
    id: string;
    staffId: string;
    name: string;
    rank: string;
    onboard_date: string;
    offboard_date: string;
    class_certificate: string;
	certificateNumber: string;
    date_of_issue: string;
    radio_comm_emergency: boolean;
    radio_tests: boolean;
};

export interface IPrintTableGMDSSLogEntry {
    dateTime: string;
    stationTo: string;
    stationFrom: string;
    actions: string;
    frequency: string;
    operator: string;
    isRed?: boolean;
    hasRedText?: boolean;
}

interface IPrintTableGMDSSLogSection {
    title: string;
    subtitle?: string;
    entries: IPrintTableGMDSSLogEntry[];
}

interface IPrintTableGMDSSLogCategory {
    categoryName: string;
    bgColor: string;
    sections: IPrintTableGMDSSLogSection[];
    notes?: { text: string; style: string }[];
}

export interface IPrintGMDSSTableData {
    categories: IPrintTableGMDSSLogCategory[];
}

